import React from 'react'
import {API_URL} from "../../services/api"

interface SourceLogoProps {
  source: string
  classExtra: string
}

export const SourceLogo: React.FC<SourceLogoProps> = ({ source, classExtra }) => {
  if (source.includes('AUTO')) {
    return (
      <img
        className={`${classExtra} rounded-lg object-cover`}
        src={`${API_URL}/sources/surplusauto.jpg`}
        alt={source}
      />
    )
  }

  if (source.includes('MOTO')) {
    return (
      <img
        className={`${classExtra} rounded-lg object-cover`}
        src={`${API_URL}/sources/surplusmoto.jpg`}
        alt={source}
      />
    )
  }

  if (source.includes('INDUSTRIE')) {
    return (
      <img
        className={`${classExtra} rounded-lg object-cover`}
        src={`${API_URL}/sources/${source.replace(/ /g, '').toLowerCase()}.jpg`}
        alt={source}
      />
    )
  }

  return (
    <div className="w-14 h-14 bg-gray-200 rounded-lg flex items-center justify-center text-xs text-gray-500 border-2 border-dashed border-gray-300">
    </div>
  )
}
